import { useEffect, useState } from "react";
import { Mail, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import api from "@/lib/api";

export default function EmailPreviewDialog({ trigger, defaultOpen = false, onClosed }) {
  const [open, setOpenState] = useState(defaultOpen);
  const setOpen = (v) => { setOpenState(v); if (!v) onClosed?.(); };
  const [kinds, setKinds] = useState([]);
  const [kind, setKind] = useState(null);
  const [preview, setPreview] = useState(null);
  const [sending, setSending] = useState(false);
  useEffect(() => { if (open) api.emailPreviewKinds().then((r) => { setKinds(r.kinds); if (!kind && r.kinds[0]) setKind(r.kinds[0].kind); }).catch(() => {}); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (kind) { setPreview(null); api.emailPreview(kind).then(setPreview).catch(() => toast.error("Anteprima non disponibile")); } }, [kind]);
  const sendTest = async () => {
    setSending(true);
    try { const r = await api.emailPreviewSend(kind); toast.success(`Email di prova inviata a ${r.sent_to}`); } catch (e) { toast.error(e?.response?.data?.detail || "Invio non riuscito"); } finally { setSending(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger || <Button variant="outline" className="gap-2 border-border" data-testid="open-email-preview-button"><Mail className="h-4 w-4" /> Anteprima email</Button>}</DialogTrigger>
      <DialogContent className="max-w-4xl" data-testid="email-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Mail className="h-5 w-5" /> Anteprima email</DialogTitle>
          <DialogDescription>Come appaiono le email in uscita con il tema Nouvelle Contest (dati di esempio). Puoi inviarti una copia di prova.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 md:grid-cols-[220px_1fr]">
          <ul className="space-y-1" data-testid="email-preview-kinds">
            {kinds.map((k) => (
              <li key={k.kind}>
                <button type="button" onClick={() => setKind(k.kind)} data-testid={`email-kind-${k.kind}`}
                  className={`w-full text-left rounded-lg px-3 py-2 text-sm transition-colors ${kind === k.kind ? "bg-primary/10 text-primary font-semibold border border-primary/30" : "hover:bg-secondary text-foreground"}`}>{k.label}</button>
              </li>
            ))}
          </ul>
          <div className="space-y-2 min-w-0">
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <p className="text-sm"><span className="text-muted-foreground">Oggetto:</span> <b data-testid="email-preview-subject">{preview?.subject || "…"}</b></p>
              <Button size="sm" className="gap-1.5" disabled={!preview || sending} onClick={sendTest} data-testid="email-preview-send-test"><Send className="h-3.5 w-3.5" /> Inviami un test</Button>
            </div>
            <div className="rounded-lg border border-border overflow-hidden bg-slate-50">
              {preview ? <iframe title="Anteprima email" srcDoc={preview.html} sandbox="" className="w-full h-[60vh] bg-white" data-testid="email-preview-frame" /> : <div className="h-[60vh] grid place-items-center text-sm text-muted-foreground">Caricamento…</div>}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
